(function(){

    'use strict';

        // **********************************
        //  Data that this directive needs
        // ----------------------------------
        //
        //

    function pxCardAndCodes(
        $timeout, $filter, toastr, $http, Utils
    ) {
        return {
        restrict: 'EA',
        scope: {
            tenant: '=tenant',
            me: '=me'
        },
        templateUrl: 'app/components/settings/secureSettings/cardAndCodes/cardAndCodes.template.html',
        link: function(scope) {

            var userAuthenticationManagement_COPY = null;
            scope.UPDATING = false;

            (() => {
                getUserAuthenticationManagement();
            })();

            function getUserAuthenticationManagement () {
                var url = scope.tenant.info._embedded.securePrintConfiguration._links['px:userAuthenticationManagement'].href;
                $http.get(url).then((response) => {
                    scope.userAuthenticationManagement = response.data;
                    userAuthenticationManagement_COPY = angular.copy(response.data);
                }).catch((error) => {
                    console.log('error', error);
                });
            }

            scope.update = () => {
                scope.UPDATING = true;
                var url = scope.userAuthenticationManagement._links.self.href;
                var patch = Utils.getObjectsDifferencesForPatching(userAuthenticationManagement_COPY, scope.userAuthenticationManagement);
                $http.patch(url, patch).then((response) => {
                    userAuthenticationManagement_COPY = angular.copy(response.data);
                    toastr.success($filter('translate')('ChangesSaved'));
                    scope.UPDATING = false;
                }).catch((error) => {
                    toastr.error($filter('translate')('Error'));
                    scope.UPDATING = false;
                });
            };

            scope.$on('$destroy', function() {
            });

        }
        };
    }

    pxCardAndCodes.$inject = ['$timeout', '$filter', 'toastr', '$http', 'Utils'];

    angular
        .module('printix-admin')
        .directive('pxCardAndCodes', pxCardAndCodes);

})();
